import { Redirect } from 'expo-router';

/**
 * Legacy path → `/universal` (bookmarks / old CMS links).
 */
export default function BloomUniversalRedirect() {
  return <Redirect href="/universal" />;
}
